class LikeList extends HTMLElement {
    static wishlistVersion = '1.2'

    constructor() {
        super();
        this.wishlistKey = '__product_wishlist__';
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    addAllToCart() {
        const addToCartForms = document.querySelectorAll('.like-list__item--wrapper form');
        const addToCartItems = []

        this.loading(true);

        try {
            addToCartForms.forEach(form => {
                const formData = new FormData(form);
                const storeCode = this.getCookie('mor_store_code');
                const variantId = formData.get('id');
                const quantity = formData.get('quantity') || 1;
                
                if (variantId) {
                    const item = {
                        id: variantId,
                        quantity: parseInt(quantity)
                    };
                    
                    if (storeCode) {
                        item.attributes = {
                            'mor_store_code': storeCode
                        };
                    }
                    
                    addToCartItems.push(item);
                }
            });

            if (addToCartItems.length === 0) {
                console.warn('No items to add to cart');
                this.loading(false);
                return;
            }
        } catch (error) {
            console.error('Error preparing cart items:', error);
            this.loading(false);
            return;
        }
        
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: addToCartItems })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return response.json();
            } else {
                return response.text().then(text => {
                    console.log('Non-JSON response:', text);
                    return { success: true, message: text };
                });
            }
        })
        .then(data => {
            console.log('All products added to cart:', data);
            window.location.href = '/cart';
        })
        .catch(error => {
            console.error('Error adding products to cart:', error);
        })
        .finally(() => {
            this.loading(false);
        });
    }

    getLikedProducts() {
        this.collectList = JSON.parse(
            localStorage.getItem(this.wishlistKey) || "[]"
        );

        if (this.collectList.length > 0) {
            this.renderProducts();

            this.noDataDom ? this.noDataDom.style.display = 'none' : null;
            this.productsContainer ? this.productsContainer.style.display = 'block' : null;
        } else {
            this.loading(false);
            this.noDataDom ? this.noDataDom.style.display = 'block' : null;
            this.productsContainer ? this.productsContainer.style.display = 'none' : null;
        }
    }

    updateProductQuantityByHandle() {
        let likedProducts = JSON.parse(localStorage.getItem(this.wishlistKey) || "[]");
        const qtyDoms = this.querySelectorAll('like-qty-input');

        qtyDoms.forEach(qtyDom => {
            const handle = qtyDom.getAttribute('data-product-handle');
            const inputDom = qtyDom.querySelector('input.quantity__input');
            const addToCartForm = qtyDom.closest('.like-list__item--wrapper').querySelector('form');
            let formQtyInput = null;
            if (addToCartForm) {
                formQtyInput = addToCartForm.querySelector('input[name="quantity"]');
            }
            const index = likedProducts.findIndex(item => item.handle === handle);

            if (index !== -1) {
                inputDom.value = likedProducts[index].qty || 1;
                if (formQtyInput) {
                    formQtyInput.value = likedProducts[index].qty || 1;
                }
            }
        })
    }

    getRandomIntByTimestamp() {
        const timestamp = Date.now().toString();
        const randomInt = parseInt(timestamp.slice(-6));

        return randomInt;
    }

    renderProducts() {
        this.productItemTemplate = this.querySelector('template[data-like-item]').content;
        console.log('this.productItemTemplate', this.productItemTemplate);
        const renderedProductContainer = this.querySelector('.product-list__container');
        
        this.collectList.forEach(product => {
            const sectionId = this.getRandomIntByTimestamp();
            const productClone = this.productItemTemplate.cloneNode(true);
            const productHtml = productClone.querySelector('.like-list__item--wrapper');
            const imageDom = productHtml.querySelector('.item-info img');
            const titleDom = productHtml.querySelector('.like-list__item-title a');
            const skuDom = productHtml.querySelector('.like-list__item-sku span');
            const likeQtyInputDom = productHtml.querySelector('like-qty-input');
            const qtyDom = productHtml.querySelector('like-qty-input input[name="quantity"]');
            const formQtyInputDom = productHtml.querySelector('product-form input[name="quantity"]');
            const removeDom = productHtml.querySelector('like-remove');
            const productFormDom = productHtml.querySelector('product-form');
            const productFormIdInputDom = productFormDom ? productFormDom.querySelector('input[name="id"]') : null;

            imageDom ? imageDom.src = product.img : null;
            titleDom ? titleDom.textContent = product.title : null;
            titleDom ? titleDom.href = product.url : null;
            skuDom ? skuDom.textContent = product.sku : null;
            likeQtyInputDom ? likeQtyInputDom.setAttribute('data-product-handle', product.handle) : null;
            qtyDom ? qtyDom.value = product.qty : null;
            qtyDom ? qtyDom.setAttribute('id', 'Quantity-' + sectionId) : null;
            formQtyInputDom ? formQtyInputDom.value = product.qty : null;
            removeDom ? removeDom.setAttribute('data-product-handle', product.handle) : null;
            productFormDom ? productFormDom.setAttribute('data-section-id', sectionId) : null;
            productFormIdInputDom ? productFormIdInputDom.value = product.variantId : null;

            renderedProductContainer.appendChild(productHtml);
        });
    }

    loading(isLoading) {
        const addLoadingWrapper = document.querySelector('.like-list');

        if (isLoading) {
        addLoadingWrapper.classList.add('loading');
        } else {
        addLoadingWrapper.classList.remove('loading');
        }
    }

    checkVersion() {
        const getwishlistVersion = localStorage.getItem('__product_wishlist_version__');
        if (getwishlistVersion !== LikeList.wishlistVersion) {
            localStorage.removeItem(this.wishlistKey);
            localStorage.setItem('__product_wishlist_version__', LikeList.wishlistVersion);
        }
    }
    
    connectedCallback() {
        // this.loading(true);
        this.checkVersion();
        this.productTemplate = this.querySelector('[data-like-product-template]');
        this.productsContainer = this.querySelector('.like-list__items');
        this.noDataDom = this.querySelector('.no-data');
        this.sectionId = this.closest('.shopify-section').id;
        this.loadingSpinner = document.querySelector('.like-list > .loading__spinner');
        
        this.getLikedProducts();
    }
}

customElements.define('like-list', LikeList);

// class LikeQtySelect extends HTMLElement {
//     constructor() {
//         super();
//         this.qtyCount = this.querySelector('.qty-count');
//         this.qtyDetails = this.querySelector('.item-qty__details');
//     }

//     bindOptionsClick() {
//         this.options.forEach(option => {
//             option.addEventListener('click', () => {
//                 const selectedQty = option.getAttribute('data-qty');
//                 this.options.forEach(opt => opt.classList.remove('selected'));
//                 option.classList.add('selected');
//                 this.qtyCount.textContent = selectedQty;
//                 this.formQtyInput ? this.formQtyInput.value = selectedQty : null;
//                 this.qtyDetails.removeAttribute('open');
//             });
//         });
//     }

//     connectedCallback() {
//         this.qtyCount.textContent = '1';
//         this.options = this.qtyDetails.querySelectorAll('.qty-options__button');
//         this.addToCartForm = this.closest('.like-list__item--wrapper').querySelector('form');
//         if (this.addToCartForm) {
//             this.formQtyInput = this.addToCartForm.querySelector('input[name="quantity"]');
//         }
//         this.bindOptionsClick();
        
//     }
// }

// customElements.define('like-qty-select', LikeQtySelect);


class LikeQtyInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input.quantity__input');
        this.decreaseButton = this.querySelector('button[name="minus"]');
        this.increaseButton = this.querySelector('button[name="plus"]');
        this.wishlistKey = '__product_wishlist__';
    }

    bindEvents() {
        this.decreaseButton.addEventListener('click', () => {
            let currentValue = parseInt(this.input.value) || 1;
            if (currentValue > 1) {
                this.input.value = currentValue - 1;
            }

            this.updateQuantity();
        });

        this.increaseButton.addEventListener('click', () => {
            let currentValue = parseInt(this.input.value) || 1;
            this.input.value = currentValue + 1;

            this.updateQuantity();
        });

        this.input.addEventListener('change', () => {
            let currentValue = parseInt(this.input.value) || 1;
            if (currentValue < 1) {
                currentValue = 1;
            }

            this.input.value = currentValue;

            this.updateQuantity();
        });
    }

    updateQuantity() {
        if (this.formQtyInput) {
            this.formQtyInput.value = this.input.value;
        }
        this.updateStorageQuantity();
    }

    updateStorageQuantity() {
        const productHandle = this.getAttribute('data-product-handle');
        let likedProducts = JSON.parse(localStorage.getItem(this.wishlistKey) || "[]");
        const productIndex = likedProducts.findIndex(item => item.handle === productHandle);
        if (productIndex !== -1) {
            likedProducts[productIndex].qty = parseInt(this.input.value) || 1;
            localStorage.setItem(this.wishlistKey, JSON.stringify(likedProducts));

            window.dispatchEvent(new Event("wishlist:change"));
        }
    }

    connectedCallback() {
        this.addToCartForm = this.closest('.like-list__item--wrapper').querySelector('form');
        if (this.addToCartForm) {
            this.formQtyInput = this.addToCartForm.querySelector('input[name="quantity"]');
        }
        this.bindEvents();
    }
}

customElements.define('like-qty-input', LikeQtyInput);

class LikeRemove extends HTMLElement {

    constructor() {
        super();

        this.wishlistKey = '__product_wishlist__';
        this.removeButton = this.querySelector('.like-list__item-remove');
    }

    bindRemoveClick() {
        this.removeButton.addEventListener('click', () => {
            const productHandle = this.getAttribute('data-product-handle');
            let likedProducts = JSON.parse(localStorage.getItem(this.wishlistKey) || "[]");
            likedProducts = likedProducts.filter(product => product.handle !== productHandle);
            localStorage.setItem(this.wishlistKey, JSON.stringify(likedProducts));
            this.closest('.like-list__item--wrapper').remove();
            if (likedProducts.length === 0) {
                const likeList = document.querySelector('like-list');
                if (likeList) {
                    likeList.noDataDom ? likeList.noDataDom.style.display = 'block' : null;
                    likeList.productsContainer ? likeList.productsContainer.style.display = 'none' : null;
                }
            }
            window.dispatchEvent(new Event("wishlist:change"));
        });
    }

    connectedCallback() {
        this.bindRemoveClick();
    }
}

customElements.define('like-remove', LikeRemove);

class LikeAddAllToCart extends HTMLElement {
    constructor() {
        super();
        this.addAllButton = this.querySelector('.like-list__add-all-to-cart');
    }

    bindAddAllClick() {
        this.addAllButton.addEventListener('click', () => {
            const likeList = document.querySelector('like-list');
            if (likeList) {
                likeList.addAllToCart();
            }
        });
    }

    connectedCallback() {
        this.bindAddAllClick();
    }
}

customElements.define('like-add-all-to-cart', LikeAddAllToCart);